import { ICustoPrevistoVGVMensal } from "../../../Interfaces/AssistenciaTecnica/CustoPrevistoVGVMensal/CustoPrevistoVGVMensalInterface";
import {
    AtualizacaoDeCustosPrevistoVGVMensalService,
    CadastroDeCustosPrevistoVGVMensalService,
    DeleteDeCustosPrevistoVGVMensalService,
    GetCustosPrevistoVGVMensalService,
    ListagemDeCustosPrevistoVGVMensalService,
} from "../../../Services/AssistenciaTecnica/CustoPrevistoVGVMensalRelatorioBI/CustoPrevistoVGVMensalRelatorioBIService";
import { Controller } from "../../Controller";

export async function CadastroDeCustosPrevistoVGVMensalController(
    requestBody: ICustoPrevistoVGVMensal
) {
    return Controller(CadastroDeCustosPrevistoVGVMensalService(requestBody));
}

export async function GetCustosPrevistoVGVMensalController(ID_CUSTO: number) {
    return Controller(GetCustosPrevistoVGVMensalService(ID_CUSTO));
}

export async function ListagemDeCustosPrevistoVGVMensalController() {
    return Controller(ListagemDeCustosPrevistoVGVMensalService());
}

export async function AtualizacaoDeCustosPrevistoVGVMensalController(
    requestBody: Array<ICustoPrevistoVGVMensal>
) {
    return Controller(AtualizacaoDeCustosPrevistoVGVMensalService(requestBody));
}

export async function DeleteDeCustosPrevistoVGVMensalController(ID: number) {
    return Controller(DeleteDeCustosPrevistoVGVMensalService(ID));
}
